import {Component, Input, OnInit} from '@angular/core';
import {Recipe} from "../../dtos/recipe";

@Component({
  selector: 'app-recipe-card',
  templateUrl: './recipe-card.component.html',
  styleUrls: ['./recipe-card.component.css']
})
export class RecipeCardComponent implements OnInit {

  @Input() recipe: Recipe;
  showShadow: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  updateShadow(show: boolean) {
    this.showShadow = show;
  }

}
